import {Routes} from '@angular/router';

export const returngoodsManagementRoutes: Routes = [
  {
    path: 'returnGoodsManagement',
    data: { title: '退货管理' },
    children: [
      {
        path: '',
        loadComponent: () => import('./returngoods-management.component').then(m => m.ReturngoodsManagementComponent),
        data: { title: '退货管理' },
      },
      {
        path: 'returnGoodsDetail',
        loadComponent: () => import('./returngoods-detail/returngoods-detail.component').then(m => m.ReturngoodsDetailComponent),
        data: { title: '退货明细' },
      },
      {
        path: 'returnGoodsDetail/:returnGoodsOrderId',
        loadComponent: () => import('./returngoods-detail/returngoods-detail.component').then(m => m.ReturngoodsDetailComponent),
        data: { title: '退货明细' },
      },
    ]
  },
];
